import { useAuth } from "../contexts/AuthContext";

export default function Header(props) {

  const { user } = useAuth();

  return (
    <header className="z-20 h-16 flex items-center justify-between px-4 sticky top-0 bg-white border-b border-gray-200">
      <div className="py-5">
        <button onClick={props.controlSideBar} className="lg:hidden p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>

      { user?.profile?.external_image_link ? (
        <img className='relative w-12 h-12 rounded-full' src={user.profile.external_image_link} alt='Rounded Avatar'></img>
        
      ) : (
        <div className='relative w-12 h-12 bg-gray-100 flex justify-center items-center rounded-full'>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M15.9998 7C15.9998 9.20914 14.2089 11 11.9998 11C9.79067 11 7.99981 9.20914 7.99981 7C7.99981 4.79086 9.79067 3 11.9998 3C14.2089 3 15.9998 4.79086 15.9998 7Z" stroke="#4B5563" strokeWidth="1.6" />
          <path d="M11.9998 14C9.15153 14 6.65091 15.3024 5.23341 17.2638C4.48341 18.3016 4.10841 18.8204 4.6654 19.9102C5.2224 21 6.1482 21 7.99981 21H15.9998C17.8514 21 18.7772 21 19.3342 19.9102C19.8912 18.8204 19.5162 18.3016 18.7662 17.2638C17.3487 15.3024 14.8481 14 11.9998 14Z" stroke="#4B5563" strokeWidth="1.6" />
          </svg>
        </div>
      )}
      
    </header>
  )
}